import { useState, useEffect, useCallback } from 'react';
import { useStore } from '../store/useStore';
import { CURRENCIES, DEFAULT_EXCHANGE_RATES } from '../constants';

/**
 * Custom hook for currency management
 * Provides currency conversion, exchange rates, and currency symbol
 * @returns {Object} { convertPrice, currencySymbol, selectedCurrency, exchangeRates }
 */
export const useCurrency = () => {
  const selectedCurrency = useStore((state) => state.selectedCurrency);
  const [exchangeRates, setExchangeRates] = useState(DEFAULT_EXCHANGE_RATES);

  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
        if (response.ok) {
          const data = await response.json();
          setExchangeRates({
            USD: 1,
            EUR: data.rates.EUR || 0.92,
            GEL: data.rates.GEL || 2.7
          });
        }
      } catch (error) {
        // Use fallback rates if API fails
        setExchangeRates(DEFAULT_EXCHANGE_RATES);
      }
    };
    fetchExchangeRates();
  }, []);

  const convertPrice = useCallback((priceUSD) => {
    const rate = exchangeRates[selectedCurrency];
    const converted = parseFloat(priceUSD) * rate;
    const roundedTo5Units = Math.round(converted / 5) * 5;
    return roundedTo5Units.toFixed(2);
  }, [exchangeRates, selectedCurrency]);

  const currencySymbol = CURRENCIES[selectedCurrency].symbol;

  return { convertPrice, currencySymbol, selectedCurrency, exchangeRates };
};
